import { useQuery } from 'react-query';

import { getCacheSettings } from 'common/helpers';
import { QUERY_KEYS } from 'consts/queryKeys';
import { getCounties } from 'modules/_common/api';

export const useQueryCounties = (enabled: boolean | undefined) => {
  return useQuery(QUERY_KEYS.RENTALS_COUNTIES, getCounties, {
    ...getCacheSettings(),
    enabled: enabled ?? false,
  });
};
